/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "تۈنۈگۈن",
        "0": "بۈگۈن",
        "1": "ئەتە",
        "future": {
          "one": "{0} كۈندىن كېيىن",
          "other": "{0} كۈندىن كېيىن"
        },
        "past": {
          "one": "{0} كۈن ئىلگىرى",
          "other": "{0} كۈن ئىلگىرى"
        }
      },
      "day-narrow": {
        "-1": "تۈنۈگۈن",
        "0": "بۈگۈن",
        "1": "ئەتە",
        "future": {
          "one": "{0} كۈندىن كېيىن",
          "other": "{0} كۈندىن كېيىن"
        },
        "past": {
          "one": "{0} كۈن ئىلگىرى",
          "other": "{0} كۈن ئىلگىرى"
        }
      },
      "day-short": {
        "-1": "تۈنۈگۈن",
        "0": "بۈگۈن",
        "1": "ئەتە",
        "future": {
          "one": "{0} كۈندىن كېيىن",
          "other": "{0} كۈندىن كېيىن"
        },
        "past": {
          "one": "{0} كۈن ئىلگىرى",
          "other": "{0} كۈن ئىلگىرى"
        }
      },
      "hour": {
        "0": "this hour",
        "future": {
          "one": "{0} سائەتتىن كېيىن",
          "other": "{0} سائەتتىن كېيىن"
        },
        "past": {
          "one": "{0} سائەت ئىلگىرى",
          "other": "{0} سائەت ئىلگىرى"
        }
      },
      "hour-narrow": {
        "0": "this hour",
        "future": {
          "one": "{0} سائەتتىن كېيىن",
          "other": "{0} سائەتتىن كېيىن"
        },
        "past": {
          "one": "{0} سائەت ئىلگىرى",
          "other": "{0} سائەت ئىلگىرى"
        }
      },
      "hour-short": {
        "0": "this hour",
        "future": {
          "one": "{0} سائەتتىن كېيىن",
          "other": "{0} سائەتتىن كېيىن"
        },
        "past": {
          "one": "{0} سائەت ئىلگىرى",
          "other": "{0} سائەت ئىلگىرى"
        }
      },
      "minute": {
        "0": "this minute",
        "future": {
          "one": "{0} مىنۇتتىن كېيىن",
          "other": "{0} مىنۇتتىن كېيىن"
        },
        "past": {
          "one": "{0} مىنۇت ئىلگىرى",
          "other": "{0} مىنۇت ئىلگىرى"
        }
      },
      "minute-narrow": {
        "0": "this minute",
        "future": {
          "one": "{0} مىنۇتتىن كېيىن",
          "other": "{0} مىنۇتتىن كېيىن"
        },
        "past": {
          "one": "{0} مىنۇت ئىلگىرى",
          "other": "{0} مىنۇت ئىلگىرى"
        }
      },
      "minute-short": {
        "0": "this minute",
        "future": {
          "one": "{0} مىنۇتتىن كېيىن",
          "other": "{0} مىنۇتتىن كېيىن"
        },
        "past": {
          "one": "{0} مىنۇت ئىلگىرى",
          "other": "{0} مىنۇت ئىلگىرى"
        }
      },
      "month": {
        "-1": "ئۆتكەن ئاي",
        "0": "بۇ ئاي",
        "1": "كېلەر ئاي",
        "future": {
          "one": "{0} ئايدىن كېيىن",
          "other": "{0} ئايدىن كېيىن"
        },
        "past": {
          "one": "{0} ئاي ئىلگىرى",
          "other": "{0} ئاي ئىلگىرى"
        }
      },
      "month-narrow": {
        "-1": "ئۆتكەن ئاي",
        "0": "بۇ ئاي",
        "1": "كېلەر ئاي",
        "future": {
          "one": "{0} ئايدىن كېيىن",
          "other": "{0} ئايدىن كېيىن"
        },
        "past": {
          "one": "{0} ئاي ئىلگىرى",
          "other": "{0} ئاي ئىلگىرى"
        }
      },
      "month-short": {
        "-1": "ئۆتكەن ئاي",
        "0": "بۇ ئاي",
        "1": "كېلەر ئاي",
        "future": {
          "one": "{0} ئايدىن كېيىن",
          "other": "{0} ئايدىن كېيىن"
        },
        "past": {
          "one": "{0} ئاي ئىلگىرى",
          "other": "{0} ئاي ئىلگىرى"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-narrow": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-short": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "second": {
        "0": "now",
        "future": {
          "one": "{0} سېكۇنتتىن كېيىن",
          "other": "{0} سېكۇنتتىن كېيىن"
        },
        "past": {
          "one": "{0} سېكۇنت ئىلگىرى",
          "other": "{0} سېكۇنت ئىلگىرى"
        }
      },
      "second-narrow": {
        "0": "now",
        "future": {
          "one": "{0} سېكۇنتتىن كېيىن",
          "other": "{0} سېكۇنتتىن كېيىن"
        },
        "past": {
          "one": "{0} سېكۇنت ئىلگىرى",
          "other": "{0} سېكۇنت ئىلگىرى"
        }
      },
      "second-short": {
        "0": "now",
        "future": {
          "one": "{0} سېكۇنتتىن كېيىن",
          "other": "{0} سېكۇنتتىن كېيىن"
        },
        "past": {
          "one": "{0} سېكۇنت ئىلگىرى",
          "other": "{0} سېكۇنت ئىلگىرى"
        }
      },
      "week": {
        "-1": "ئۆتكەن ھەپتە",
        "0": "بۇ ھەپتە",
        "1": "كېلەر ھەپتە",
        "future": {
          "one": "{0} ھەپتىدىن كېيىن",
          "other": "{0} ھەپتىدىن كېيىن"
        },
        "past": {
          "one": "{0} ھەپتە ئىلگىرى",
          "other": "{0} ھەپتە ئىلگىرى"
        }
      },
      "week-narrow": {
        "-1": "ئۆتكەن ھەپتە",
        "0": "بۇ ھەپتە",
        "1": "كېلەر ھەپتە",
        "future": {
          "one": "{0} ھەپتىدىن كېيىن",
          "other": "{0} ھەپتىدىن كېيىن"
        },
        "past": {
          "one": "{0} ھەپتە ئىلگىرى",
          "other": "{0} ھەپتە ئىلگىرى"
        }
      },
      "week-short": {
        "-1": "ئۆتكەن ھەپتە",
        "0": "بۇ ھەپتە",
        "1": "كېلەر ھەپتە",
        "future": {
          "one": "{0} ھەپتىدىن كېيىن",
          "other": "{0} ھەپتىدىن كېيىن"
        },
        "past": {
          "one": "{0} ھەپتە ئىلگىرى",
          "other": "{0} ھەپتە ئىلگىرى"
        }
      },
      "year": {
        "-1": "ئۆتكەن يىل",
        "0": "بۇ يىل",
        "1": "كېلەر يىل",
        "future": {
          "one": "{0} يىلدىن كېيىن",
          "other": "{0} يىلدىن كېيىن"
        },
        "past": {
          "one": "{0} يىل ئىلگىرى",
          "other": "{0} يىل ئىلگىرى"
        }
      },
      "year-narrow": {
        "-1": "ئۆتكەن يىل",
        "0": "بۇ يىل",
        "1": "كېلەر يىل",
        "future": {
          "one": "{0} يىلدىن كېيىن",
          "other": "{0} يىلدىن كېيىن"
        },
        "past": {
          "one": "{0} يىل ئىلگىرى",
          "other": "{0} يىل ئىلگىرى"
        }
      },
      "year-short": {
        "-1": "ئۆتكەن يىل",
        "0": "بۇ يىل",
        "1": "كېلەر يىل",
        "future": {
          "one": "{0} يىلدىن كېيىن",
          "other": "{0} يىلدىن كېيىن"
        },
        "past": {
          "one": "{0} يىل ئىلگىرى",
          "other": "{0} يىل ئىلگىرى"
        }
      }
    },
    "locale": "ug"
  });
}